/**
 * @generated SignedSource<<ca04d9eb8bef009a9da76656a4139b82>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSetUserEmailMarketingEnabledMutation_user$data = {
  readonly rowId: any;
  readonly " $fragmentType": "useSetUserEmailMarketingEnabledMutation_user";
};
export type useSetUserEmailMarketingEnabledMutation_user$key = {
  readonly " $data"?: useSetUserEmailMarketingEnabledMutation_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSetUserEmailMarketingEnabledMutation_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSetUserEmailMarketingEnabledMutation_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3cc70e85c2dea12cc0c144dca4c599c3";

export default node;
